import { Dropdown } from 'component/Dropdown/Dropdown'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { getSortIconName, getSortTitle, Sort } from 'page/catalog/store/Sort'

export const SortButton = observer(() => {
  const demo = useDemo()
  const { stand } = demo
  const { sort } = demo.form
  const options: Sort[] = ['popular', 'name', 'latest', 'oldest']
  const font = stand ? 14 : 11

  if (demo.tsum) {
    options.push('tsum_price_asc', 'tsum_price_desc')
  }

  const onSelect = useLatestCallback((value: Sort) => {
    demo.form.sort = value
  })

  const renderOption = useLatestCallback((value: Sort) => {
    return (
      <Space gap={8}>
        <Typo size={font} medium upper>
          {getSortTitle(value)}
        </Typo>
      </Space>
    )
  })

  return (
    <Dropdown
      height={32}
      title={i18n('demo.Sorting')}
      options={options}
      onSelect={onSelect}
      renderOption={renderOption}
    >
      <Space gap={8}>
        <Typo size={font} medium upper>
          {getSortTitle(sort)}
        </Typo>
        <Icon name={getSortIconName(sort)} size={16} tertiary />
      </Space>
    </Dropdown>
  )
})
